import React, { forwardRef } from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const desktopBulletSide = 24;
const padBulletSide = 24;
const phoneBulletSide = 24;

const desktopBulletSpacing = 24;
const padBulletSpacing = 24;
const phoneBulletSpacing = 16;

const blockStyles = makeStyles(theme => ({
  root: {
    margin: "0px",
    padding: "0px",
    paddingLeft: `${20 + desktopBulletSide + desktopBulletSpacing}px`,
    ['@media (max-width: 992px)']: {
      paddingLeft: `${20 + padBulletSide + padBulletSpacing}px`,
    },
    ['@media (max-width: 768px)']: {
      paddingLeft: `${20 + phoneBulletSide + phoneBulletSpacing}px`,
    },
    "& li": {
      position: "relative",
      listStyleType: "none",
      marginBottom: "14px",
      minHeight: `${desktopBulletSide}px`,
      display: "flex",
      alignItems: "center",
      ['@media (max-width: 992px)']: {
        marginBottom: "14px",
        minHeight: `${padBulletSide}px`,
      },
      ['@media (max-width: 768px)']: {
        marginBottom: "12px",
        minHeight: `${phoneBulletSide}px`,
      },
    },
    "& li:before": {
      content: '" "',
      position: "absolute",
      backgroundRepeat: "no-repeat",
      left: `-${desktopBulletSide + desktopBulletSpacing}px`,
      backgroundSize: `${desktopBulletSide}px ${desktopBulletSide}px`,
      width: `${desktopBulletSide}px`,
      height: `${desktopBulletSide}px`,
      ['@media (max-width: 992px)']: {
        left: `-${padBulletSide + padBulletSpacing}px`,
        backgroundSize: `${padBulletSide}px ${padBulletSide}px`,
        width: `${padBulletSide}px`,
        height: `${padBulletSide}px`,
        
      },
      ['@media (max-width: 768px)']: {
        left: `-${phoneBulletSide + phoneBulletSpacing}px`,
        backgroundSize: `${phoneBulletSide}px ${phoneBulletSide}px`,
        height: `${phoneBulletSide}px`,
        width: `${phoneBulletSide}px`,
      },
    },
    "& li:last-child": {
      marginBottom: "0px"
    }
  },
}));

const List = forwardRef((props, ref) => {
  const classes = blockStyles();
  const { className, children } = props;

  return (
    <ul className = { clsx(classes.root, className) }
        ref = { ref } >
      { children }
    </ul>
  );
});

export default List;